import AppPDFViewer from "./AppPDFViewer";

export default AppPDFViewer;